import { useAppDispatch } from '../../useReduxToolkit';
import * as realtime from '../../../features/realtime/realtime.slice';
import { RealtimeMessageType } from '../../../features/realtime/realtime.types';
import { ScreenshareRequestPayload } from '../screenshareState.types';
import { setCurrentRequestedMember } from '../../../features/screenshare/screenshare.slice';
import { TrackedEvents } from '../../../features/tracking/track';
import { useTrack } from '../../useTrack';

export const useSendScreenshareRequest = (): ((
  realtimeMemberId: string,
) => Promise<void>) => {
  const track = useTrack();
  const dispatch = useAppDispatch();

  const sendScreenshareRequest = async (id: string): Promise<void> => {
    await dispatch(
      realtime.sendMessage({
        id,
        message: {
          messageType: RealtimeMessageType.ScreenshareRequest,
          payload: { eventName: ScreenshareRequestPayload.Request },
        },
      }),
    );

    dispatch(setCurrentRequestedMember(id));
    void track(TrackedEvents.ButtonClicked, {
      button_action: 'Screenshare Requested',
    });
  };

  return async (realtimeMemberId: string): Promise<void> => {
    await sendScreenshareRequest(realtimeMemberId);
  };
};
